/* The Apps Labz theme behavior.
   Adapted from the static site's js/app.js for Shopify:
   the header and footer are rendered server-side (blocks/header.liquid
   and blocks/footer.liquid), so this script only wires up the mobile
   menu, the light/dark toggle, the page-transition curtain and the
   cursor canvas. */
(function () {
  var body = document.body;

  /* ---- Page transition curtain ---- */
  var overlay = document.createElement('div');
  overlay.className = 'page-transition';
  overlay.setAttribute('aria-hidden', 'true');
  body.insertBefore(overlay, body.firstChild);

  /* ---- Mobile menu ---- */
  var toggle = document.getElementById('menu-toggle');
  var menu = document.getElementById('mobile-menu');
  function closeMenu() {
    if (menu) {
      menu.setAttribute('hidden', '');
    }
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden');
      if (open) {
        menu.removeAttribute('hidden');
      } else {
        menu.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', String(open));
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        closeMenu();
      }
    });
  }

  /* ---- Theme (light/dark) ---- */
  var root = document.documentElement;
  function apply(theme) {
    if (theme === 'dark') {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
    }
    try {
      localStorage.setItem('apps-labz-theme', theme);
    } catch (e) {}
    document.querySelectorAll('[data-theme-btn]').forEach(function (btn) {
      var dark = theme === 'dark';
      btn.setAttribute('aria-pressed', String(dark));
      btn.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
      var label = btn.querySelector('.theme-label');
      if (label) {
        label.textContent = dark ? 'Light mode' : 'Dark mode';
      }
    });
  }
  var btns = document.querySelectorAll('[data-theme-btn]');
  if (btns.length) {
    apply(root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark');
        if (btn.classList.contains('nav__mobile-theme')) {
          closeMenu();
        }
      });
    });
  }

  /* ---- Close any open menu on Escape ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && !menu.hasAttribute('hidden')) {
      closeMenu();
    }
  });

  /* ---- Wireframe cursor effect (fine pointers + motion OK only) ---- */
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer =
    window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  if (reduceMotion || !finePointer) {
    return;
  }

  var canvas = document.createElement('canvas');
  canvas.id = 'wireframe-cursor-canvas';
  body.appendChild(canvas);
  var ctx = canvas.getContext('2d');

  var mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  var PARTICLE_COUNT = 4;
  var particles = [];

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  window.addEventListener('resize', resizeCanvas);
  resizeCanvas();

  window.addEventListener('mousemove', function (e) {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
  });

  for (var i = 0; i < PARTICLE_COUNT; i++) {
    particles.push({
      x: mouse.x,
      y: mouse.y,
      friction: 0.08 + i * 0.03,
      offsetX: (Math.random() - 0.5) * 25,
      offsetY: (Math.random() - 0.5) * 25,
      radius: 6
    });
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Center anchor dot
    ctx.beginPath();
    ctx.arc(mouse.x, mouse.y, 3, 0, Math.PI * 2);
    ctx.fillStyle = '#871F78';
    ctx.shadowBlur = 12;
    ctx.shadowColor = 'rgba(135, 31, 120, 0.8)';
    ctx.fill();

    particles.forEach(function (p, index) {
      var targetX = mouse.x + p.offsetX;
      var targetY = mouse.y + p.offsetY;

      p.x += (targetX - p.x) * p.friction;
      p.y += (targetY - p.y) * p.friction;

      // Lines connecting center to nodes
      ctx.beginPath();
      ctx.moveTo(mouse.x, mouse.y);
      ctx.lineTo(p.x, p.y);
      ctx.strokeStyle = 'rgba(135, 31, 120, ' + (0.5 - index * 0.08) + ')';
      ctx.lineWidth = 1.5;
      ctx.shadowBlur = 0;
      ctx.stroke();

      // Outer floating node balls
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(135, 31, 120, 0.85)';
      ctx.fill();

      // Mesh lines connecting the balls together
      if (index > 0) {
        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        ctx.lineTo(particles[index - 1].x, particles[index - 1].y);
        ctx.strokeStyle = 'rgba(135, 31, 120, 0.2)';
        ctx.stroke();
      }
    });

    requestAnimationFrame(animate);
  }

  animate();
})();
